<template>
  <div
    class="chuangguan"
    :class="ifMobile ? 'mobile' : 'comp'"
  >
    <div class="index">
      <div class="header">{{ user.name }}的闯关战报</div>
      <div class="report-part">
        <div class="title"><span>测评结果</span></div>
        <div class="report-content">
          <!-- <div class="round">
            <img
              class="pin"
              :style="`transform: rotateZ(${-150+(avaScore.通用/5)*300}deg);`"
              src="./img/pin.png"
            />
            <div
              class="markt-ava"
              :style="`transform: rotateZ(12deg);`"
            >
              <div :style="`transform: rotateZ(-12deg);`">2.7</div>
            </div>
            <div
              class="alpha-ava"
              :style="`transform: rotateZ(${-150+(rank.ava/5)*300}deg);`"
            >
              <div :style="`transform: rotateZ(${-(-150+(rank.ava/5)*300)}deg);`">{{rank.ava}}</div>
            </div>
            <div class="round-name">{{rankName(avaScore.通用)}}</div>
          </div> -->
          <div
            class="round"
            id="round"
          >
          </div>
          <div class="round-tips">
            <div class="round-tip blue">低于市场平均</div>
            <div class="round-tip green">高于市场平均</div>
            <div class="round-tip red">高于公司平均</div>
          </div>
          <div
            class="round-info"
            style="text-align: center;margin-bottom: 0;"
          >
            你的测评分数为<span>{{ avaScore.通用 }}</span>分<b>（满分5分）</b> <br />
            市场平均分为<span>2.7</span>分，同期顾问平均分为<span>{{this.rank.ava || 3.57}}</span>分，你超越<span>{{rank.percent}}%</span>猎头。
          </div>
        </div>
      </div>
      <div class="report-part">
        <div class="title"><span>基础能力</span></div>
        <div
          class="report-content"
          style="padding-top: 0"
        >
          <div id="radar-echart1"></div>
          <div
            class="round-info"
            v-html="baseText.通用"
          ></div>
        </div>
      </div>
      <div class="report-part">
        <div class="title"><span>工作能力</span></div>
        <div
          class="report-content"
          style="padding-top: 40px"
        >
          <div class="ecahrt-tabs">
            <div
              class="echart-tab"
              :class="curTab === item ? 'active-tab' : ''"
              v-for="(item, idx) in scoreItem"
              :key="idx"
              @click="changeTab(item)"
            >
              {{ item }}
            </div>
          </div>
          <div id="radar-echart2"></div>
          <div class="round-info">
            <span>{{curTab.split('方向')[0]}}</span>得分{{avaScore[curTab]}}分，在{{curTab.split('方向')[0]}}的角色，是一个{{avaScore[curTab]>3.5?'非常适合':'比较适合'}}你的发展方向；
            <br />
            <div v-html="baseText[curTab]"></div>
          </div>
          <div class="score-detail">
            <div
              class="score-detail-wrap"
              v-if="curTab === '顾问方向'"
            >
              <div
                class="score-detail-item"
                v-for="(value, key) in 顾问方向"
                :key="key"
              >
                <div class="score-detail-name">{{ key }}</div>
                <div class="score-detail-value-wrap">
                  <div class="score-detail-value">
                    <el-progress
                      :stroke-width="20"
                      v-if="value"
                      :percentage="(value * 100) / 5"
                      :format="formatProgress"
                      :color="customColors"
                    ></el-progress>
                    <span class="progress-max-label">/5分</span>
                  </div>
                </div>
                <div class="score-detail-desc">
                  {{comment[key][valueRank[value]]}}
                </div>
              </div>
            </div>
            <div
              class="score-detail-wrap"
              v-if="curTab === '客户经理方向'"
            >
              <div
                class="score-detail-item"
                v-for="(value, key) in 客户经理方向"
                :key="key"
              >
                <div class="score-detail-name">{{ key }}</div>
                <div class="score-detail-value-wrap">
                  <div class="score-detail-value">
                    <el-progress
                      :stroke-width="20"
                      v-if="value"
                      :percentage="(value * 100) / 5"
                      :format="formatProgress"
                      :color="customColors"
                    ></el-progress>
                    <span class="progress-max-label">/5分</span>
                  </div>
                </div>
                <div class="score-detail-desc">
                  {{comment[key][valueRank[value]]}}
                </div>
              </div>
            </div>
            <div
              class="score-detail-wrap"
              v-if="curTab === '业务支持方向'"
            >
              <div
                class="score-detail-item"
                v-for="(value, key) in 业务支持方向"
                :key="key"
              >
                <div class="score-detail-name">{{ key }}</div>
                <div class="score-detail-value-wrap">
                  <div class="score-detail-value">
                    <el-progress
                      :stroke-width="20"
                      v-if="value"
                      :percentage="(value * 100) / 5"
                      :format="formatProgress"
                      :color="customColors"
                    ></el-progress>
                    <span class="progress-max-label">/5分</span>
                  </div>
                </div>
                <div class="score-detail-desc">
                  {{comment[key][valueRank[value]]}}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="report-part">
        <div class="title"><span>管理能力</span></div>
        <div
          class="report-content"
          style="padding-top: 0"
        >
          <div id="radar-echart3"></div>
        </div>
      </div>
      <div class="report-part">
        <div class="title"><span>学习目标</span></div>
        <div
          class="report-content"
          style="padding-top: 40px"
        >
          <div class="round-info">
            根据你的评定报告，生成了你的学习计划；通过六个月的学习，你会具备百万顾问的技能，会超过市场上80%的猎头，相当于国内3年经验优秀猎头的知识储备和能力水平。
          </div>
          <div class="table">
            <div class="table-name">{{ user.name }}的课表</div>
            <div class="table-header">
              <div class="table-item">阶段</div>
              <div class="table-item">建议学时</div>
              <div class="table-item">课程简介</div>
              <div class="table-item">进度</div>
            </div>
            <div
              class="table-row"
              v-for="item in classList"
              :key="item.title"
            >
              <div
                class="table-item"
                :class="item.checked?'table-item-del':user.current_step_name===item.title?'table-item-cur':''"
              >{{item.title}}</div>
              <div
                class="table-item"
                :class="item.checked?'table-item-del':user.current_step_name===item.title?'table-item-cur':''"
              >{{item.time}}</div>
              <div
                class="table-item"
                :class="item.checked?'table-item-del':user.current_step_name===item.title?'table-item-cur':''"
              >{{item.desc}}</div>
              <div
                class="table-item"
                :class="item.checked?'table-item-del':user.current_step_name===item.title?'table-item-cur':''"
              >
                <!-- <i
                  class="el-icon-check"
                  v-if="item.checked"
                ></i> -->
                {{item.cur}}/{{item.total}}
              </div>
            </div>
          </div>
          <!-- <div class="btn">查看完整课程体系</div> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
const echarts = require('echarts/lib/echarts')
require('echarts/lib/component/title')
require('echarts/lib/component/legend')
require('echarts/lib/chart/radar')
require('echarts/lib/chart/gauge')
export default {
  data() {
    return {
      ifMobile: false,
      curTab: '顾问方向',
      myChart1: null,
      myChart2: null,
      myChart3: null,
      myChart4: null,
      user: {},
      rankNames: ['猎头小菜鸟', '猎头小耕牛', '猎头后备役', '优秀猎头', '猎头佼佼者', '猎头大神', '天生的猎头'],
      通用: {
        目标导向: 0,
        抗压能力: 0,
        适应能力: 0,
        决策行动: 0,
        学习能力: 0,
        逻辑分析: 0,
      },
      顾问方向: {
        人际建立: 0,
        沟通说服: 0,
        匹配分析: 0,
        意向把控: 0,
        人选推动: 0,
        mapping: 0,
      },
      客户经理方向: {
        人际建立: 0,
        沟通说服: 0,
        客户开拓: 0,
        谈判能力: 0,
        客情维护: 0,
        项目推进: 0,
      },
      业务支持方向: {
        人际建立: 0,
        成就他人: 0,
        与人合作: 0,
        数据维护: 0,
        支持协作: 0,
        书面表达: 0,
      },
      管理能力: {
        成就他人: 0,
        战略思维: 0,
        创新能力: 0,
        策略经营: 0,
        计划组织: 0,
        领导监督: 0,
      },
      通用标准分: {
        目标导向: 0,
        抗压能力: 0,
        适应能力: 0,
        决策行动: 0,
        学习能力: 0,
        逻辑分析: 0,
      },
      顾问方向标准分: {
        人际建立: 0,
        沟通说服: 0,
        匹配分析: 0,
        意向把控: 0,
        人选推动: 0,
        mapping: 0,
      },
      客户经理方向标准分: {
        人际建立: 0,
        沟通说服: 0,
        客户开拓: 0,
        谈判能力: 0,
        客情维护: 0,
        项目推进: 0,
      },
      业务支持方向标准分: {
        人际建立: 0,
        成就他人: 0,
        与人合作: 0,
        数据维护: 0,
        支持协作: 0,
        书面表达: 0,
      },
      管理能力标准分: {
        成就他人: 0,
        战略思维: 0,
        创新能力: 0,
        策略经营: 0,
        计划组织: 0,
        领导监督: 0,
      },
      rateArr: {
        通用: ['目标导向', '抗压能力', '适应能力', '决策行动', '学习能力', '逻辑分析'],
        顾问方向: [
          '目标导向',
          '抗压能力',
          '决策行动',
          '逻辑分析',
          '人际建立',
          '沟通说服',
          '匹配分析',
          '意向把控',
          '人选推动',
          'mapping',
        ],
        客户经理方向: [
          '目标导向',
          '抗压能力',
          '适应能力',
          '决策行动',
          '学习能力',
          '逻辑分析',
          '人际建立',
          '沟通说服',
          '客户开拓',
          '谈判能力',
          '客情维护',
          '项目推进',
        ],
        业务支持方向: ['人际建立', '成就他人', '与人合作', '数据维护', '支持协作', '书面表达'],
        管理能力: [
          '目标导向',
          '决策行动',
          '学习能力',
          '人员管理',
          '战略思维',
          '创新能力',
          '策略经营',
          '计划组织',
          '领导监督',
        ],
      },
      rank: {},
      scoreItem: ['顾问方向', '客户经理方向', '业务支持方向'],
      customColors: [
        { color: '#e4035d', percentage: 21 },
        { color: '#e4035d', percentage: 41 },
        { color: '#aa3d93', percentage: 61 },
        { color: '#38adfd', percentage: 81 },
        { color: '#38adfd', percentage: 100 },
      ],
      valueRank: ['低', '低', '低', '中', '高', '高'],
      classList: [
        {
          title: '新手村',
          time: '入职一周内',
          desc: '了解阿尔法&了解猎头',
          checked: false,
          total: 7,
          cur: 0,
        },
        {
          title: '第一阶段',
          time: '入职四周内',
          desc: '基本工作方法和知识',
          checked: false,
          total: 13,
          cur: 0,
        },
        {
          title: '第二阶段',
          time: '入职八周内',
          desc: '项目交付能力和方法',
          checked: false,
          total: 9,
          cur: 0,
        },
        {
          title: '第三阶段',
          time: '入职十八周',
          desc: '猎头经验和技巧提升',
          checked: false,
          total: 11,
          cur: 0,
        },
        {
          title: '第四阶段',
          time: '入职二十周',
          desc: '专职进阶课程',
          checked: false,
          total: 11,
          cur: 0,
        },
        {
          title: '能力选修课',
          time: '入职二十四周',
          desc: '专属课程，针对性提高',
          checked: false,
          total: 7,
          cur: 0,
        },
      ],
      comment: {
        人际建立: {
          高: '能够轻松建立良好的客户及同事关系；与各个阶层的人士关系融洽；建立宽广和有效的人际网络；适当地运用幽默，与你沟通充满愉悦。',
          中: '能够相对容易的与客户、同事建立良好的关系。即使是陌生人，你也能相对轻松地建立人际关系。',
          低: '建立人际关系也许不是你的特长，但是在猎头的工作当中，这是非常重要的一项。在接下来的工作学习中，可以尽量提高此项技能。',
        },
        沟通说服: {
          高: '通过说服和协商赢得他人明确的同意和承诺；有效利用行政手段影响和说服他人；从个人或他人角度去提出其观点和游说；施展强烈的个人影响力。',
          中: '说服沟通是不错的能力，在职位的推进过程当中，你可以利用你的能力去把握人选的意向诉求，这也是猎头很重要的能力。',
          低: '说服沟通也许并不是你的强项，不过没关系，我们的课程中，有大量关于说服沟通的内容。马上刷起来吧！',
        },
        客户开拓: {
          高: '客户开发拓展能力极强，可以单独完成客户的BD工作，马上去BD客户吧！',
          中: '客户开发拓展能力较强，可以在同事及丰富数据的辅助下完成客户的开发工作。建议多出去见见客户、多了解客户需求，丰富自己的经验。',
          低: '可以多浏览客户会面记录，多学习培训中BD相关课程。提高自己对客户需求的了解能力。',
        },
        谈判能力: {
          高: '谈判能力极强，拥有不错的思维能力、观察能力、反应能力和表达能力。',
          中: '谈判能力较强，能在与客户、候选人交流的流程中，为自己争取有利条件。',
          低: '在谈判的过程当中，要多把握候选人的意向与诉求。建议多学习培训中的沟通、意向把握等课程。',
        },
        客情维护: {
          高: '客情维护能力极强，所对接的客户都会有极其丰富的数据，可以帮助其他顾问更快地了解客户需求，赞！',
          中: '客情维护能力较强，在与客户的对接过程当中，能够了解到客户的信息、需求，丰富我们的认知。',
          低: '客情维护在我们做单的过程中还是很重要的呢，毕竟更好地了解客户才能更好地为客户服务。',
        },
        项目推进: {
          高: '项目推进速度超快，每次在接到职位之后，都能马上推动项目进展。不光如此，还说明你有不错的决策能力，知道如果快速推进事情的发展。',
          中: '项目推进能力较强，能够不错滴把我项目的关键节点，在做单的过程当中，速度还是很重要的。',
          低: '项目推进能力是非常重要的，可以多学习一下我们项目推进的相关课程哦，提高自己的项目推进能力。',
        },
        匹配分析: {
          高: '匹配分析能力极强，能够迅速判断职位需求，并能寻访出合适人选。也说明你有着不错的逻辑分析能力，可以分析事物之间多层因果。',
          中: '匹配分析能力较强，能够在职位需求明确的情况下，较快地寻访出合适人选。',
          低: '可以多使用系统的【智能匹配】【一键匹配】等功能，多学习培训中的人选分析课，快快提高匹配分析能力哦。',
        },
        意向把控: {
          高: '能够精准把握人选的求职意向，在与候选人沟通后，就能马上判断出候选人的意向是否积极，为后续的推进打下了良好的基础呢。',
          中: '能够较为准确地把握人选的求职意向，在与候选人沟通后，能基本判断出候选人的意向是否积极。',
          低: '意向把控对于我们来说，十分重要的呢，这方面的能力要重视起来，可以多看看我们相关的培训课程哦。',
        },
        人选推动: {
          高: '人选推动能力极强，能够在做职位的时候，快速推动候选人',
          中: '人选推动不错，能够在做职位的时候，较为快速地推进职位的进展',
          低: '在职位的推进过程中，需要增强自己的推进能力，可以多看看相关的培训课程哦',
        },
        mapping: {
          高: 'mapping能力极强，能够迅速梳理出一个企业的框架，这也有助于日后做单。',
          中: '拥有不错的mapping能力，在工作的同时，还能梳理出一个企业的架构，这对我们建立对公司的认知十分有用呢。',
          低: 'mapping对于我们的日常工作还是很重要的，可以多看看我们mapping的相关课程呢。',
        },
        成就他人: {
          高: '是一个能够在工作中成就他人的小天使，在完成自己工作的同时，还能不忘成就他人。',
          中: '在日常的工作中，能不错地成就他人。',
          低: '不能光顾着自己埋头苦干哦，在合适的时候也要适当地成就他人。',
        },
        与人合作: {
          高: '能够很好地尊重团队成员的观点和贡献；认同、聆听、支持和关心他人；咨询他人，和他人分享信息和专业技术；建立团队精神和调解冲突；适应团队并融入其中。',
          中: '能够较好地与团队进行配合，别人在与你合作中能够感受到一定的助力。',
          低: '任何一项工作，都不是自己一个人能够完成的。在职位的推进过程中，要积极地与他合作哦。',
        },
        数据维护: {
          高: '数据维护能力超强！你总是能把无序的数据变得井井有条，你就是阿尔法最强“首席数据师”。',
          中: '能不错的维护日常数据，作为赋能最重要的一环，数据对我们来说非常重要，加油，请继续努力！',
          低: '闷头做业务的同时，也要维护好自己的数据哦。',
        },
        支持协作: {
          高: '你是一个强力辅助，在业务推进的过程中，不光需要摧城拔寨的将军，还需要运筹帷幄的军师，不用怀疑，你就是阿尔法的“最强辅助”！',
          中: '你是一个值得信赖的队友，在职位的推动过程当中，你总是能出现在大家需要你的地方。',
          低: '支持协作也许不是你的强项，在职位的推进过程当中，不是一个人就可以完成的哦，平日的工作里可以适当提高自己的协作能力哦。',
        },
        书面表达: {
          高: '书面表达让人信服；内容清晰、简洁和准确；避免不必要地使用行话和难以理解的语言；内容结构清晰和富有逻辑；信息的组织满足听众的需求，并为听众着想。',
          中: '书面表达能力较强，行文清晰，内容结构清晰和富有逻辑，能够完成不错的《推荐报告》《年度报告》。  ',
          低: '我们有海量优秀的行业报告，这些报告不光能体现我们与众不同的专业性，还能俘获客户与候选人的芳心哦。快去读读这些报告吧，也许下一份行业重磅报告，就会出自你的手中。',
        },
      },
    }
  },
  computed: {
    baseText() {
      const 通用Arr = Object.keys(this.通用).map((t) => ({
        key: t,
        value: this.通用[t],
      }))
      const 通用Map = {
        目标导向: '明确的目标感,',
        抗压能力: '无惧困难，坚韧，永不放弃的精神',
        学习能力: '不断进化，超越自己',
        适应能力: '适应变化，不断努力',
        决策能力: '当机立断，快速行动',
        逻辑分析: '超强的逻辑分析',
      }
      let 通用 = ''
      通用Arr.sort((a, b) => b.value - a.value)
      const final通用Arr = 通用Arr.filter((t) => t.value === 通用Arr[0].value)
      if (final通用Arr.length >= 4) {
        通用 =
          final通用Arr
            .map((f) => f.key)
            .filter(Boolean)
            .map((f) => `<span>${f}</span>`)
            .join('、') + '均衡的能力发展，全能型选手，没什么能难住你。'
      } else {
        通用 =
          '你在工作中最强的武器是' +
          final通用Arr
            .map((f) => f.key)
            .filter(Boolean)
            .map((f) => `<span>${f}</span>`)
            .join('、') +
          '。'
      }

      const 顾问方向Arr = this.rateArr.顾问方向.map((t) => ({
        key: t,
        value: this.顾问方向[t] || this.通用[t],
      }))
      let 顾问方向 = ''
      顾问方向Arr.sort((a, b) => b.value - a.value)
      const final顾问方向Arr = 顾问方向Arr.filter((t) => t.value === 顾问方向Arr[0].value)
      顾问方向 =
        final顾问方向Arr
          .map((f) => f.key)
          .filter(Boolean)
          .map((f) => `<span>${f}</span>`)
          .join('、') + '方面会有不俗的表现。'

      const 客户经理方向Arr = this.rateArr.客户经理方向.map((t) => ({
        key: t,
        value: this.客户经理方向[t] || this.通用[t],
      }))
      let 客户经理方向 = ''
      客户经理方向Arr.sort((a, b) => b.value - a.value)
      const final客户经理方向Arr = 客户经理方向Arr.filter((t) => t.value === 客户经理方向Arr[0].value)
      客户经理方向 =
        final客户经理方向Arr
          .map((f) => f.key)
          .filter(Boolean)
          .map((f) => `<span>${f}</span>`)
          .join('、') + '方面会有不俗的表现。'

      const 业务支持方向Arr = this.rateArr.业务支持方向.map((t) => ({
        key: t,
        value: this.业务支持方向[t] || this.通用[t],
      }))
      let 业务支持方向 = ''
      业务支持方向Arr.sort((a, b) => b.value - a.value)
      const final业务支持方向Arr = 业务支持方向Arr.filter((t) => t.value === 业务支持方向Arr[0].value)
      业务支持方向 =
        final业务支持方向Arr
          .map((f) => f.key)
          .filter(Boolean)
          .map((f) => `<span>${f}</span>`)
          .join('、') + '方面会有不俗的表现。'
      return {
        通用,
        顾问方向,
        客户经理方向,
        业务支持方向,
      }
    },
    avaScore() {
      return {
        通用:
          Math.ceil(
            (Object.keys(this.通用)
              .map((e) => Object.assign({}, this.通用)[e])
              .reduce((a, b) => a + b, 0) /
              Object.keys(this.通用).length) *
              10,
          ) / 10,
        顾问方向:
          Math.ceil(
            (this.rateArr.顾问方向
              .map((e) => Object.assign({}, this.顾问方向, this.通用)[e])
              .reduce((a, b) => a + b, 0) /
              this.rateArr.顾问方向.length) *
              10,
          ) / 10,
        客户经理方向:
          Math.ceil(
            (this.rateArr.客户经理方向
              .map((e) => Object.assign({}, this.客户经理方向, this.通用)[e])
              .reduce((a, b) => a + b, 0) /
              this.rateArr.客户经理方向.length) *
              10,
          ) / 10,
        业务支持方向:
          Math.ceil(
            (this.rateArr.业务支持方向
              .map((e) => Object.assign({}, this.业务支持方向, this.通用)[e])
              .reduce((a, b) => a + b, 0) /
              this.rateArr.业务支持方向.length) *
              10,
          ) / 10,
        管理能力:
          Math.ceil(
            (this.rateArr.管理能力
              .map((e) => Object.assign({}, this.管理能力, this.通用)[e])
              .reduce((a, b) => a + b, 0) /
              this.rateArr.管理能力.length) *
              10,
          ) / 10,
      }
    },
  },
  methods: {
    rankName(num) {
      if (num < 2) {
        return '猎头小菜鸟'
      } else if (num < 2.7) {
        return '猎头小耕牛'
      } else if (num < 3) {
        return '猎头后备役'
      } else if (num < 3.5) {
        return '优秀猎头'
      } else if (num < 4) {
        return '猎头佼佼者'
      } else if (num < 4.5) {
        return '猎头大神'
      } else if (num < 5) {
        return '天生的猎头'
      }
    },
    async indexInit() {
      await this.getData()
      await this.getUserInfo()
      const chartDom1 = document.getElementById('radar-echart1')
      const chartDom2 = document.getElementById('radar-echart2')
      const chartDom3 = document.getElementById('radar-echart3')
      const chartDom4 = document.getElementById('round')
      this.myChart1 = echarts.init(chartDom1)
      this.myChart2 = echarts.init(chartDom2)
      this.myChart3 = echarts.init(chartDom3)
      this.myChart4 = echarts.init(chartDom4)
      let option1 = this.getOption(1)
      let option2 = this.getOption(2)
      let option3 = this.getOption(3)
      let option4 = this.getGuageOption()
      option1 && this.myChart1.setOption(option1)
      option2 && this.myChart2.setOption(option2)
      option3 && this.myChart3.setOption(option3)
      option4 && this.myChart4.setOption(option4)
      await this.getLesson()
    },
    getGuageOption() {
      let option
      option = {
        series: [
          {
            type: 'gauge',
            min: 0,
            max: 5,
            radius: '95%',
            axisLine: {
              lineStyle: {
                width: 30,
                color: [
                  // [
                  //   1,
                  //   new echarts.graphic.LinearGradient(0, 0, 1, 0, [
                  //     {
                  //       offset: 2.7 / 5,
                  //       color: '#3c72f4',
                  //     },
                  //     {
                  //       offset: (this.rank.ava || 3.57) / 5,
                  //       color: '#60c38d',
                  //     },
                  //     {
                  //       offset: 1,
                  //       color: '#e43824',
                  //     },
                  //   ]),
                  // ],
                  [2.7 / 5, '#3c72f4'],
                  [(this.rank.ava || 3.57) / 5, '#60c38d'],
                  [1, '#e43824'],
                ],
              },
            },
            pointer: {
              itemStyle: {
                color: 'auto',
              },
            },
            axisTick: {
              distance: -30,
              length: 8,
              lineStyle: {
                color: '#fff',
                width: 2,
              },
            },
            splitLine: {
              distance: -30,
              length: 30,
              lineStyle: {
                color: '#fff',
                width: 4,
              },
            },
            axisLabel: {
              color: 'auto',
              distance: 40,
              fontSize: 20,
              formatter: (value) => {
                const arr = [0, 1, 2, 3, 4, 5, 2.7, this.rank.ava || 3.57]
                if (arr.includes(value)) {
                  return value
                }
                // return value + 'km/h'
              },
            },
            detail: {
              valueAnimation: true,
              formatter: () => {
                return this.rankName(this.avaScore.通用)
              },
              color: 'auto',
              fontSize: this.ifMobile ? 20 : 30,
            },
            data: [
              {
                value: this.avaScore.通用,
              },
            ],
          },
        ],
      }
      return option
    },
    formatProgress(val) {
      return `${(val / 100) * 5}分`
    },
    changeTab(item) {
      this.curTab = item
      let option = this.getOption(2)
      option && this.myChart2.setOption(option)
    },
    async getUserInfo() {
      const { data } = await app.service('misc').getLessonMember({ tel: app.user.个人手机 || app.user.工作手机 || '' })
      this.user = data
      // this.rank = this.rankList[Math.floor(Math.abs(this.user.stars - 1) / 20)]
    },
    async getLesson() {
      const res = await app.service('misc').getLessonLevels({ tel: app.user.个人手机 || app.user.工作手机 || '' })
      if (res.status === 'fail') {
        this.$alert(
          `<h3 style="text-align:center">${res.msg}</h3><p style="text-align:center">请添加管理员微信询问解决~</p><div><img style="margin:20px auto 0;width:200px;height:200px;" src="https://alphahr-files-backup.oss-cn-beijing.aliyuncs.com/wechat/jobHunting/common/fuxingqrcode.png" alt=""></div>`,
          {
            dangerouslyUseHTMLString: true,
            confirmButtonText: '确定',
            center: true,
            showClose: false,
          },
        )
        return
      }
      const data = res.data
      const { data: plusData } = await app
        .service('misc')
        .getPlusLessons({ tel: app.user.个人手机 || app.user.工作手机 || '' })
      const levelList = data.levelList && data.levelList.length ? data.levelList : []
      const finishedLevel = data.finishedLevel && Object.keys(data.finishedLevel).length ? data.finishedLevel : {}
      this.classList.forEach((c, idx) => {
        if (levelList && levelList[0] && levelList[0].step === c.title) {
          c.cur = levelList.filter((l) => l.stars > 0).length
        }
        if (finishedLevel[c.title]) {
          c.cur = finishedLevel[c.title].length
        }
        if (c.title === '能力选修课' && plusData && plusData.length) {
          c.cur = plusData.filter((l) => l.stars > 0).length
        }
        if (c.total === c.cur && c.total !== 0) {
          c.checked = true
        }
      })
    },
    async getData() {
      // const { data } = await app.service('wechat').externalApi({
      //   baseUrl: 'http://39.107.92.53:4747',
      //   path: `/api/users/getOpqTestResult?tel=${app.user.个人手机 || app.user.工作手机 || ''}`,
      //   method: 'get',
      // })
      const { data } = await app.service('wechat').externalApi({
        path: `/api/users/getOpqTestRank?tel=${app.user.个人手机 || app.user.工作手机 || ''}`,
        method: 'get',
      })
      if (!data.user) {
        this.$alert('您还未做测评，点击确定去做测评~', {
          customClass: this.ifMobile ? 'small-alert' : '',
          confirmButtonText: '确定',
          callback: (action) => {
            if (action === 'confirm') {
              window.open('https://www.yuanshouhr.com/jobhunting/#/questionnaire', '_blank')
            }
          },
        })
        return
      }
      const {
        达成个人目标: 目标导向,
        处理压力和挫折: 抗压能力,
        适应和应对改变: 适应能力,
        有决策和采取行动: 决策行动,
        学习和研究: 学习能力,
        分析: 逻辑分析,
        联系和建立人群网络: 人际建立,
        说服和影响: 沟通说服,
        匹配分析,
        意向把控,
        人选推动,
        mapping,
        客户开拓,
        谈判能力,
        客情维护,
        项目推进,
        与人合作,
        成就他人,
        数据维护,
        支持协作,
        协作和报告: 书面表达,
        企业家和商业思维: 战略思维,
        创造和创新: 创新能力,
        制定策略和概念: 策略经营,
        计划和组织: 计划组织,
        领导和监督: 领导监督,
        人员管理,
      } = data.user.grade
      this.通用 = { 目标导向, 抗压能力, 适应能力, 决策行动, 学习能力, 逻辑分析 }
      this.顾问方向 = { 人际建立, 沟通说服, 匹配分析, 意向把控, 人选推动, mapping }
      this.客户经理方向 = { 人际建立, 沟通说服, 客户开拓, 谈判能力, 客情维护, 项目推进 }
      this.业务支持方向 = { 人际建立, 成就他人, 与人合作, 数据维护, 支持协作, 书面表达 }
      this.管理能力 = { 人员管理, 战略思维, 创新能力, 策略经营, 计划组织, 领导监督 }
      this.通用标准分 = { 目标导向: 3.6, 抗压能力: 3.1, 适应能力: 3.9, 决策行动: 3.4, 学习能力: 3.6, 逻辑分析: 3.7 }
      this.顾问方向标准分 = { 人际建立: 3.7, 沟通说服: 3.5, 匹配分析: 3.4, 意向把控: 3.6, 人选推动: 3.2, mapping: 3.7 }
      this.客户经理方向标准分 = {
        人际建立: 3.7,
        沟通说服: 3.5,
        客户开拓: 3.2,
        谈判能力: 3.4,
        客情维护: 3.6,
        项目推进: 3.4,
      }
      this.业务支持方向标准分 = {
        人际建立: 3.7,
        成就他人: 3.9,
        与人合作: 3.4,
        数据维护: 3.1,
        支持协作: 3,
        书面表达: 3.6,
      }
      this.管理能力标准分 = { 人员管理: 3.5, 战略思维: 3.8, 创新能力: 3.5, 策略经营: 3.8, 计划组织: 3.2, 领导监督: 3.9 }
      this.rank = data.rank
    },
    getOption(no) {
      if (!this['myChart' + no]) {
        return
      }
      let option
      let indicator
      if (no === 1) {
        indicator = this.rateArr.通用.map((e) => ({
          text: e,
          max: 5,
        }))
      } else if (no === 2) {
        indicator = this.rateArr[this.curTab].map((e) => ({
          text: e,
          max: 5,
        }))
      } else {
        indicator = this.rateArr.管理能力.map((e) => ({
          text: e,
          max: 5,
        }))
      }
      const value = indicator.map((e) => this.通用[e.text] || this[this.curTab][e.text] || this.管理能力[e.text])
      const value2 = indicator.map(
        (e) => this.通用标准分[e.text] || this[this.curTab + '标准分'][e.text] || this.管理能力标准分[e.text],
      )
      option = {
        legend: {
          top: 'bottom',
          textStyle: {
            color: '#fff',
          },
        },
        radar: {
          // shape: 'circle',
          indicator,
          nameGap: 5,
          axisName: {
            fontSize: this.ifMobile ? 10 : 12,
          },
        },
        series: [
          {
            name: '1',
            type: 'radar',
            data: [
              {
                value: value2,
                name: `同期顾问平均分`,
                label: {
                  show: true,
                  color: '#ddd',
                  fontSize: this.ifMobile ? 10 : 12,
                },
                symbol: 'rect',
                lineStyle: {
                  color: '#3C72F4',
                },
                areaStyle: {
                  opacity: 0.7,
                  color: '#3C72F4',
                },
                itemStyle: {
                  color: '#3C72F4',
                },
              },
              {
                value,
                label: {
                  show: true,
                  color: '#fff',
                  fontSize: this.ifMobile ? 10 : 12,
                },
                name: `${this.user.name}得分`,
                symbol: 'circle',
                areaStyle: {
                  color: '#E43824',
                  opacity: 0.7,
                },
                lineStyle: {
                  color: '#E43824',
                },
                itemStyle: {
                  color: '#E43824',
                },
              },
            ],
          },
        ],
      }
      return option
    },
  },
  async mounted() {
    this.ifMobile = /Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)
    await this.indexInit()
  },
}
</script>
<style scoped>
.index {
  background-image: url('https://alphahr-files-backup.oss-cn-beijing.aliyuncs.com/wechat/jobHunting/newChuangguan/bg.png');
  background-size: 100% 100%;
  overflow-y: auto;
}
.comp .index {
  padding-bottom: 100px;
}
.mobile .index {
  padding-bottom: 80px;
}
.mobile .header {
  height: 60px;
}
.header {
  width: 100%;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  font-weight: 400;
  color: #ffffff;
  box-shadow: 0 2px 6px 4px #00000082;
}
.mobile .report-part {
  width: 90vw;
  padding: 15px;
}
.mobile .round {
  width: 300px;
  height: 270px;
}
.mobile .pin {
  top: 41px;
}
.mobile .round-tip {
  font-size: 14px;
  white-space: nowrap;
}
.mobile .round-tips {
  margin-bottom: 20px;
}
.mobile .round-info {
  padding: 0;
  line-height: 26px;
  font-size: 16px;
}
.mobile #radar-echart1,
.mobile #radar-echart2,
.mobile #radar-echart3 {
  width: 300px;
  height: 330px;
  margin-bottom: 20px;
}
.mobile .echart-tab {
  font-size: 14px;
}
.mobile .table-item {
  font-size: 12px;
}
.report-part {
  width: 483px;
  padding: 22px;
  border: 2px solid;
  border-image: linear-gradient(90deg, #e4035d, #38adfd) 10 10;
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.5);
  border-radius: 5px;
  margin: 40px auto;
  position: relative;
}
.report-part .title {
  width: 138px;
  height: 34px;
  border: none;
  background: linear-gradient(90deg, #e4035d 0%, #38adfd 100%);
  border-radius: 4px 4px 4px 4px;
  margin-right: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  color: #ffffff;
  margin-bottom: 29px;
  transform: skewX(-15deg);
  position: absolute;
  top: -17px;
  left: 50%;
  margin-left: -69px;
}
.report-part .title span {
  transform: skewX(15deg);
}
.report-content {
  padding: 60px 0 30px;
}
.round {
  width: 435px;
  height: 400px;
  /* background-image: url('./img/round.png'); */
  /* background-size: 100% 100%; */
  /* position: relative; */
  margin: 0 auto 30px;
}
.pin {
  height: 130px;
  width: 16px;
  display: block;
  position: absolute;
  left: 167px;
  left: 50%;
  top: 59px;
  margin-left: -8px;
  transform: rotateZ(-150deg);
  transform-origin: 8px 110px;
  transition: all 0.2s ease-in-out;
}
.markt-ava,
.alpha-ava {
  font-size: 16px;
  color: #fff;
  position: absolute;
  left: 50%;
  margin-left: -15px;
  top: 70px;
  -webkit-transform-origin: 8px 110px;
  transform-origin: 8px 110px;
  width: 30px;
  text-align: center;
}
.round-name {
  font-size: 32px;
  font-weight: 600;
  color: #38acfd;
  position: absolute;
  bottom: -10px;
  left: 0;
  width: 100%;
  text-align: center;
}
.round-tips {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 50px;
  width: 100%;
}
.round-tip {
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: 400;
  display: flex;
  align-items: center;
  justify-content: center;
}
.round-tip::before {
  content: '';
  width: 10px;
  height: 10px;
  display: block;
  margin-right: 8px;
  border-radius: 50%;
}
.round-tip.blue {
  color: #3c72f4;
}
.round-tip.blue::before {
  background-color: #3c72f4;
}
.round-tip.green {
  color: #60c38d;
}
.round-tip.green::before {
  background-color: #60c38d;
}
.round-tip.red {
  color: #e43824;
}
.round-tip.red::before {
  background-color: #e43824;
}
.round-info {
  font-size: 18px;
  font-weight: 400;
  color: #ffffff;
  text-align: center;
  padding: 0 30px;
  margin-bottom: 30px;
  text-align: justify;
}

#radar-echart1,
#radar-echart2,
#radar-echart3 {
  width: 435px;
  height: 450px;
  margin: 0 auto 30px;
}
.ecahrt-tabs {
  display: flex;
  align-items: center;
  border: 1px solid #0090f1;
  border-radius: 4px;
  margin-bottom: 30px;
}
.echart-tab {
  width: 138px;
  height: 34px;
  background: #141921;
  border-right: 1px solid #0090f1;
  font-size: 18px;
  font-weight: 400;
  color: #ffffff;
  flex-grow: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.echart-tab:last-of-type {
  border: none;
}
.echart-tab.active-tab {
  background-color: #38adfd;
}
.score-detail-item {
  margin-bottom: 20px;
}
.score-detail-name {
  font-size: 18px;
  color: #fff;
  margin-bottom: 15px;
}
.score-detail-desc {
  font-size: 14px;
  color: #999;
  line-height: 20px;
  margin-top: 10px;
  padding: 0 15px;
}
.table {
  width: 100%;
  border: 1px solid #007fe3;
}
.table-name {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  color: #fff;
  background-color: #007fe3;
  height: 40px;
  font-weight: 600;
  letter-spacing: 5px;
}
.table-header,
.table-row {
  height: 30px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #007fe3;
  color: #40a5f59c;
}
.table-row:last-of-type {
  border: none;
}
.table-header {
  background-color: #40a4f563;
}
.table-item {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  border-right: 1px solid rgba(64, 165, 245, 0.61);
  height: 100%;
}
.table-item i {
  font-size: 14px;
  color: #007fe3;
  background: #fff;
  border-radius: 50%;
  padding: 2px;
  font-weight: 600;
  border: 2px solid #007fe3;
}
.table-item:first-of-type,
.table-item:nth-of-type(2) {
  width: 100px;
}
.table-item:nth-of-type(3) {
  width: 180px;
}
.table-item:last-of-type {
  border: none;
  width: 50px;
}
.btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 200px;
  height: 50px;
  border-radius: 8px;
  background-color: #e4035d;
  font-size: 18px;
  font-weight: 500;
  margin: 40px auto 0;
  cursor: pointer;
  color: #fff;
}
.score-detail-value {
  position: relative;
}
.score-detail-value .progress-max-label {
  position: absolute;
  right: 0;
  top: 0;
  font-size: 16px;
  color: #c7c7c7;
}
.table-item-del {
  text-decoration: line-through;
  color: #40a5f59c;
}
.table-item-cur {
  color: #9ad2ff;
}
</style>
<style>
.score-detail-value .el-progress {
  display: flex;
  align-items: center;
}
.score-detail-value .el-progress-bar {
  padding-right: 70px;
}
.score-detail-value .el-progress__text {
  flex-shrink: 0;
  color: #fff;
  font-size: 20px !important;
  margin-left: -5px;
}
.chuangguan .round-info span {
  font-size: 22px;
  color: #9ad2ff;
}
.chuangguan .round-info b {
  font-size: 14px;
  color: #999;
  font-weight: normal;
}
.small-alert {
  width: 80vw;
}
</style>
